// extracted by mini-css-extract-plugin
export default {"main":"SurveysPage_main__E1ZQI","menu":"SurveysPage_menu__IM0dp","workArea":"SurveysPage_workArea__IPwx-"};